import { createSelector } from "@ngrx/store";
import { IAppState } from "../state/app.state";
import { ILoadingState } from "../state/loading.state";

const selectLoading = (state: IAppState) => state.loading;

export const loadingSelector = createSelector(
  selectLoading,
  (state: ILoadingState) => state
);
